<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Today's Appointments </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Today's Appointments List</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-success float-right" style="margin-left: 7px;" @click="toggleImportModal">
                                <i class="fas fa-plus"></i> Bulk Add Patient
                            </button>-->
                            <button type="button" class="btn btn-primary float-right" @click="redirectRoute('/appointments/create')">
                                <i class="fas fa-plus"></i>
                                Add New
                            </button>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <!-- Search and export area -->
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: center;">Today's Appointment List</h3>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <!-- <div class="">
                                        <label for="from_date"> From </label>
                                        <input type="date" class="form-control" id="from_date" v-model="tableData.from_date" @change="onkeyPress('from_date')">
                                        <div class="invalid-feedback" v-if="errors.from_date">
                                            {{errors.from_date[0]}}
                                        </div>
                                    </div> -->
                                </div>

                                <div class="col-md-3">
                                    <!-- <div class="">
                                        <label for="to_date"> To </label>
                                        <input type="date" class="form-control" id="to_date" v-model="tableData.to_date" @change="onkeyPress('to_date')">
                                        <div class="invalid-feedback" v-if="errors.to_date">
                                            {{errors.to_date[0]}}
                                        </div>
                                    </div> -->
                                </div>

                                <div class="col-md-3 ">
                                    
                                </div>

                                <div class="col-md-3">
                                    <div class="mt-3" style="text-align: right;">
                                        <!-- <button type="submit" class="btn-sm btn btn-primary" :disabled="disabled" @click="filterSalesReport()">
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>Submit 
                                        </button> -->
                                        <a href="javascript:void(0);" style="margin-left: 5px;" class="btn-sm btn btn-primary" @click.prevent="printAppointmentList()" ><i class="mdi mdi-printer-outline me-1"></i> </a>
                                        <!-- <a href="javascript:void(0);" style="margin-left: 5px;" class="btn-sm btn btn-primary"
                                        @click.prevent="downloading ? null : exportToExcel()">
                                            <span v-show="downloading"  >
                                                <i class="fas fa-spinner fa-spin"></i>
                                            </span> 
                                            <i class="mdi mdi-file-excel me-1"></i> 
                                        </a> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Content Area -->
                    <div class="card">
                        <div class="card-body">   
                            <Datatable 
                                :columns="columns" 
                                :sortKey="tableData.sortKey"  
                                @sort="sortBy" 
                                v-if="!loading">
                                <template #header > 
                                    <div class="tableFilters" style="margin-bottom: 10px;">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="control" style="float: left;">
                                                    <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                    <div class="select" style="float: left;">
                                                        <select class="form-select" v-model="tableData.length" @change="getAppointmentList()"> 
                                                            <option value="10" selected="selected">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option :value="pagination.total">All</option>
                                                        </select>
                                                    </div>
                                                    <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-2">
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="getAppointmentList()">
                                            </div>
                                        </div>
                                    </div>   
                                </template> 
                                <template #body >                            
                                    <tbody v-if="appointments.length > 0">
                                        <tr class=" " v-for="(item, i) in appointments" :key="i">
                                            <td>{{ i + 1 }} </td> 
                                            <td>{{ item.appointment_date }}</td>
                                            <td>{{ item.serial_no }} </td> 
                                            <td>{{ item.patient_name }} </td> 
                                            <td>{{ item.patient_phone }} </td>
                                            <td>{{ item.schedule ? formatAppointmentTime(item.schedule.start_time) +' - '+ formatAppointmentTime(item.schedule.end_time) : '' }} </td>
                                            <td>{{ item.doctor_name }}</td>
                                            <td>{{ item.department_name }}</td>
                                            <td>
                                                <!-- <div v-if="item.status != 0" class="dropdown">
                                                <!- <div class="dropdown"> ->
                                                    <button class="btn btn-sm dropdown-toggle text-white" type="button" :class="getStatusBadgeClass(item.status)" data-bs-toggle="dropdown">
                                                        {{ getStatusLabel(item.status) }}
                                                    </button>
                                                    <ul class="dropdown-menu">
                                                        <li v-if="item.status !== 0" class="mb-1">
                                                            <a class="dropdown-item bg-warning text-white" href="javascript:void(0);" @click="updateStatus(item, 0, 'pending')">
                                                                <span>Pending</span>
                                                            </a>
                                                        </li>
                                                        <!- <li v-if="item.status !== 1" class="mb-1">
                                                            <a class="dropdown-item bg-secondary text-white" href="javascript:void(0);" @click="updateStatus(item, 1, 'confirmed')">
                                                                <span>Confirmed</span>
                                                            </a>
                                                        </li> ->
                                                        <li v-if="item.status !== 2" class="mb-1">
                                                            <a class="dropdown-item bg-info text-white" href="javascript:void(0);" @click="updateStatus(item, 2, 'present')">
                                                                <span>Present</span>
                                                            </a>
                                                        </li> 
                                                        <li v-if="item.status !== 3" class="mb-1">
                                                            <a class="dropdown-item bg-success text-white" href="javascript:void(0);" @click="updateStatus(item, 3, 'complete')">
                                                                <span>Done/Complete</span>
                                                            </a>
                                                        </li>
                                                        <li v-if="item.status !== 4" class="mb-1">
                                                            <a class="dropdown-item bg-danger text-white" href="javascript:void(0);" @click="updateStatus(item, 4, 'cancel')">
                                                                <span>Cancel</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div> -->
                                                
                                                <!-- <div v-else> -->
                                                <div>
                                                    <span class="badge bg-warning" v-if="item.status == 0">Pending/Absent</span>
                                                    <!-- <span class="badge bg-danger" v-if="item.status == 1">Absent</span> -->
                                                    <span class="badge bg-info" v-if="item.status == 2">Present</span>
                                                    <span class="badge bg-success" v-if="item.status == 3">Done/Complete</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-sm btn-light dropdown-toggle" type="button" data-bs-toggle="dropdown">
                                                        {{ 'More' }}
                                                    </button>
                                                    <ul class="dropdown-menu">
                                                        <li class="border-bottom" v-if="!item.patient_id">
                                                            <a class="dropdown-item text-primary" href="javascript:void(0);" @click="registerPatient(item)">
                                                                <i class="mdi mdi-account-multiple-plus-outline"></i> <span>Patient Registration</span>
                                                            </a>
                                                        </li> 

                                                        <li class="border-bottom" v-if="item.status == 3">
                                                            <a class="dropdown-item text-primary" href="javascript:void(0);" @click="generateSales(item)">
                                                                <i class="mdi mdi-pill"></i> <span>Generate Medicine Sale</span>
                                                            </a>
                                                        </li> 
                                                        <li class="border-bottom" v-if="item.status == 3">
                                                            <a class="dropdown-item text-primary" href="javascript:void(0);" @click="prescriptionView(item)">
                                                                <i class="mdi mdi-eye-outline"></i> <span>View Prescription</span>
                                                            </a>
                                                        </li> 

                                                        <!-- <li class="border-bottom" v-if="item.payment_status == 1 && item.status > 1 && item.status != 4">
                                                            <a class="dropdown-item text-primary" href="javascript:void(0);">
                                                                <i class="mdi mdi-currency-usd"></i> <span>Receive Payment</span>
                                                            </a>
                                                        </li> -->
                                                        <!-- <li class="border-bottom" v-if="!item.prescriptions && item.status > 1 && item.status < 3">
                                                            <a class="dropdown-item text-success" href="javascript:void(0);" @click="generatePrescription(item)">
                                                                <i class="mdi mdi-file-outline"></i> <span>Generate Prescription</span>
                                                            </a>
                                                        </li> -->
                                                        <li class="border-bottom" v-if="item.status > 1 && item.status < 3">
                                                        <!-- <li class="border-bottom"> -->
                                                            <a class="dropdown-item text-info" href="javascript:void(0);" @click="tokenPrint(item)">
                                                                <i class="mdi mdi-printer-outline"></i> <span>Print Token</span>
                                                            </a>
                                                        </li> 
                                                        <li class="border-bottom" v-if="item.status < 2">
                                                            <a class="dropdown-item text-warning" href="javascript:void(0);" @click="edit(item)">
                                                                <i class="mdi mdi-circle-edit-outline"></i> <span>Edit</span>
                                                            </a>
                                                        </li>
                                                        <li class="border-bottom" v-if="item.status < 2 || item.staus == 4">
                                                            <a class="dropdown-item text-danger" href="javascript:void(0);" @click="deleteItem(item)">
                                                                <i class="mdi mdi-delete-outline"></i> <span>Delete</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="action-btns text-center">
                                                    <!-- item-->
                                                    <!-- <a :href="getPaymentReceiveUrl(item.id)" target="_blank" class="btn btn-sm btn-primary" title="Payment Receive">
                                                        <i class="mdi mdi-currency-usd"></i>
                                                    </a>  -->
                                                    <!-- <a href="javascript:void(0);" @click="show(item)" class="btn btn-sm btn-info" title="Patient Details">
                                                        <i class="mdi mdi-eye-outline"></i>
                                                    </a>  -->
                                                    <!-- <a href="javascript:void(0);" @click="tokenPrint(item)" class="btn btn-sm btn-info" title="Print Token">
                                                        <i class="mdi mdi-printer-outline"></i>
                                                    </a>  -->
                                                    <!-- <a href="javascript:void(0);" class="btn btn-sm btn-warning" @click="edit(item)" title="Edit">
                                                        <i class="mdi mdi-circle-edit-outline"></i>
                                                    </a> -->
                                                    <!-- <a href="javascript:void(0);" class="btn btn-sm btn-danger" @click="deleteItem(item)" title="Delete">
                                                        <i class="mdi mdi-delete-outline"></i>
                                                    </a> -->
                                                    <!-- item-->
                                                </div>  
                                            </td>
                                        </tr>
                                    </tbody> 
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="8"> No Data Available Here!</td>
                                        </tr>
                                    </tbody>
                                </template> 
                                <template #footer>
                                    <Pagination 
                                        :pagination="pagination"  
                                        :language="lang"
                                        @onChangePage="setPage" > 
                                    </Pagination> 
                                </template> 
                            </Datatable>


                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <Modal @close="toggleModal()" :modalActive="modalActive">
                <div class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>New Appointment</h3>
                        <button @click="toggleModal()" type="button" class="btn btn-sm btn-danger"> <i class="mdi mdi-close-outline"></i></button>
                    </div>
                    <form @submit.prevent="submitForm()" enctype="multipart/form-data" >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <label for="patient_name" style="float: none;">Patient *</label>
                                            <input type="text" class="form-control border" v-model="form.patient_name" id="patient_name" placeholder="Patient Name Here!" @keypress="onkeyPress('patient_name')">                                                  
                                            <div class="invalid-feedback" v-if="errors.patient_name">
                                                {{errors.patient_name[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label for="patient_phone" style="float: none;">Patient Phone </label>
                                            <input type="text" class="form-control border" v-model="form.patient_phone" id="patient_phone" placeholder="Phone number Here!" @keypress="onkeyPress('patient_phone')">                                                  
                                            <div class="invalid-feedback" v-if="errors.patient_phone">
                                                {{errors.patient_phone[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label for="department_id" style="float: none;">Department *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.department_id"
                                                placeholder="Select Department"  
                                                @change="onChangeDepartment($event)"
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="department_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.department_id">
                                                {{errors.department_id[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <label for="doctor_id" style="float: none;">Doctor *</label>
                                            <Multiselect 
                                                class="form-control border" 
                                                mode="single"
                                                v-model="form.doctor_id"
                                                placeholder="Select Doctor"  
                                                :searchable="true" 
                                                :filter-results="true"
                                                :options="doctor_options"
                                                :classes="multiclasses"
                                                :close-on-select="true" 
                                                :min-chars="1"
                                                :resolve-on-load="false" 
                                                :create-option="true" 
                                                v-if="renderOptionComponent"
                                            />                                                   
                                            <div class="invalid-feedback" v-if="errors.doctor_id">
                                                {{errors.doctor_id[0]}}
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="appointment_date">Date *</label>
                                                <input type="date" class="form-control border" @keypress="onkeyPress('appointment_date')" v-model="form.appointment_date" id="appointment_date" placeholder="Pulse Rate"> 
                                                <div class="invalid-feedback" v-if="errors.appointment_date">
                                                    {{errors.appointment_date[0]}}
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="col-md-6" v-if="!editMode">
                                            <div class="form-group">
                                                <label for="cost_center_id">Cost Center </label>
                                                <treeselect 
                                                    v-model="form.cost_center_id"
                                                    :multiple="false" 
                                                    :always-open="false"
                                                    :options="costCenterOptions"
                                                    :value-consists-of="valueConsistsOf"
                                                    :normalizer="normalizer"
                                                    :default-expand-level="Infinity"
                                                    :disable-branch-nodes="true"
                                                    :search-nested="true"                                                
                                                    placeholder='Select Cost Center'
                                                    v-if="renderOptionComponent"
                                                />
                                                <div class="invalid-feedback" v-if="errors.cost_center_id">
                                                    {{errors.cost_center_id[0]}}
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="col-md-6" v-if="!editMode">
                                            <div class="form-group">
                                                <label for="paying_by">Paying by </label>
                                                <select id="paying_by" v-model="form.payment_type" class="form-control border">
                                                    <option value="cash">Cash</option>
                                                    <option value="card">Card</option>
                                                </select>
                                                <div class="invalid-feedback" v-if="errors.payment_type">
                                                    {{errors.payment_type[0]}}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6" v-if="!editMode">
                                            <div class="form-group">
                                                <label for="amount">Amount </label>
                                                <input type="number" step="any" onmousewheel="return false" v-model="form.amount" id="amount" class="form-control" />
                                                <div class="invalid-feedback" v-if="errors.amount">
                                                    {{errors.amount[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div> 
                            </div>
                        </div>
                        <div class="modal-footer"> 
                            <button type="button" class="btn btn-danger" @click="toggleModal()">
                                Close
                            </button> 
                            <button type="submit" class="btn btn-primary " :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span>{{btn}} 
                            </button> 
                        </div>
                    </form>
                </div>
            </Modal>
            
            <!-- Customer Profile Modal -->
            <Modal @close="toggleProfileModal()" :modalActive="showModal">
                <div class="modal-content scrollbar-width-thin customer-show-modal">
                    <div class="modal-header"> 
                        <h5 class="">Details Info</h5>
                        <button @click="toggleProfileModal" type="button" class="btn btn-default">X</button>
                    </div>
                    <div class="modal-body" v-if="customer">  
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-5">    
                                            <img :src="customer.cimage" v-if="customer.cimage" width="200">
                                        </div> <!-- end col -->
                                        <div class="col-lg-7"> 
                                            <!-- Product title -->
                                            <div class="col-md-12">
                                                <h3 class="mt-0">{{ customer.name }}  </h3>  
                                                <table class="table table-responsive">
                                                    <tr>
                                                        <td>Phone: </td>
                                                        <td>{{ customer.phone }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Email: </td>
                                                        <td>{{ customer.email }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Address: </td>
                                                        <td>{{ customer.address }}</td>
                                                    </tr>
                                                </table>
                                            </div>  

                                        </div> <!-- end col -->
                                    </div> <!-- end row-->
                                    <div class="table-responsive mt-4">
                                        <table class="table table-bordered table-centered mb-0"> 
                                            <tbody>
                                                <tr>
                                                    <td>Patient Type</td>
                                                    <td>{{ customer.customer_group_name }}</td> 
                                                </tr> 
                                                <tr>
                                                    <td>Gender</td>
                                                    <td>{{ customer.gender }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Date of Birth</td>
                                                    <td>{{ customer.dob }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Blood Group</td>
                                                    <td>{{ customer.blood_group }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Status</td>
                                                    <td>
                                                    <span class="badge bg-success" v-if="customer.status">Active</span> 
                                                    <span class="badge bg-danger" v-else>Inactive</span> 
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td>Address 2</td>
                                                    <td>{{ (customer.address_secondary != 'null') ? customer.address_secondary : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Facebook URL</td>
                                                    <td>{{ (customer.facebook_url != 'null') ? customer.facebook_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Twitter URL</td>
                                                    <td>{{ (customer.twitter_url != 'null') ? customer.twitter_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Instagram URL</td>
                                                    <td>{{ (customer.instagram_url != 'null') ? customer.instagram_url : '' }}</td> 
                                                </tr>
                                                <tr>
                                                    <td>Linkedin URL</td>
                                                    <td>{{ (customer.linkedin_url != 'null') ? customer.linkedin_url : '' }}</td> 
                                                </tr>
                                                
                                            </tbody>
                                            </table>
                                        </div> 
                                    <div class="col-md-12"> 
                                    <div class="form-row">
                                        <div class="form-group col-md-3">
                                            
                                        </div>
                                    </div>
                                    </div>
                                </div> <!-- end card-body-->
                            </div> <!-- end card-->
                        </div> <!-- end col-->  
                    </div>
                    </div>
                </div>
            </Modal>


            <!-- Print Modal -->
            <Modal @close="togglePrintModal()">
                <div class="modal-content scrollbar-width-thin appointment-print" >
                    <div class="modal-header"> 
                        <button @click="togglePrintModal()" type="button" class="btn btn-default">X</button>
                        <h3 style="width: 100%">Today's Appointment List</h3>
                    </div>
                    <div class="modal-body " id="printArea" >
                        <div class="table-responsive appointment_list">
                            <table class="table po_invoice">
                                <tr>
                                    <td colspan="2" class="text-center" style="position: relative;">
                                        <h5 class="text-uppercase">{{ this.retailShopName }}</h5>
                                        <h6 class="text-uppercase">{{ this.retailSmallText }}</h6>
                                        <p>{{ this.retailShopAddress }} </p>
                                        <p>Dhaka, Bangladesh</p> 
                                        <h4 style="text-align: center;">Today's Appointment List</h4>
                                        <!-- <h5 style="text-align: center;" v-if="from_date != '' && to_date != ''">From {{ from_date }} TO {{ to_date }}</h5> -->
                                    </td>
                                </tr>
                            </table>
                            <table style="width: 100%;" class="table-bordered table-centered table-nowrap">
                                <thead>
                                    <tr>
                                        <th>SL </th>
                                        <th>Date</th>
                                        <th>Appointment ID</th> 
                                        <th>Patient</th> 
                                        <th>Phone</th> 
                                        <th>Doctor</th> 
                                        <th>Department </th> 
                                    </tr>
                                </thead>
                                <tbody v-if="appointments.length > 0">
                                    <tr class="border" v-for="(item, i) in appointments" :key="i">
                                        <td class="text-center">{{ i + 1 }} </td>
                                        <td class="text-left">{{ item.appointment_date }} </td>
                                        <td class="text-left">{{ item.appointment_id }} </td>
                                        <td class="text-left">{{ item.patient_name ?? 'N/A' }} </td>
                                        <td class="text-left">{{ item.patient_phone ?? 'N/A' }} </td>
                                        <td class="text-left">{{ item.doctor_name ?? 'N/A' }} </td>
                                        <td class="text-left">{{ item.department_name ?? 'N/A' }} </td>                                        
                                    </tr> 
                                </tbody>
                            </table> 
                        </div>
                    </div>
                </div>
            </Modal>

            <!-- Token Print Modal-->
            <Modal @close="toggleTokenPrintModal()" :modalActive="tokenPrintModalActive">
            <!-- <Modal @close="toggleTokenPrintModal()"> -->
                <div class="modal-content scrollbar-width-thin appointment-print" >
                    <div class="modal-header"> 
                        <h3 style="width: 100%">Appointment Token</h3>
                        <button style="float: right;" @click="toggleTokenPrintModal()" type="button" class="btn btn-danger">X</button>
                    </div>
                    <div class="modal-body " id="printTokenArea" >
                        <div id="printTokenReceipt">
                            <div class="page">
                                <!-- HEADER -->
                                <div class="header">
                                    <h2>{{ this.prescriptionHospitalName }}</h2>
                                    <small>{{ this.prescriptionAddress }}<br>
                Phone: {{ this.prescriptionPhone }} | Email: {{ this.prescriptionEmail }}</small>
                                </div>

                                <!-- PATIENT BASIC INFO -->
                                <div class="section">
                                    <div>
                                        <h4 style="text-align: center; margin-top: -10px; padding: 10px 15px; display: block;"><strong style="background-color: #282828; color: #fff; padding: 8px 15px;">OUT-PATIENT RECORD</strong></h4>
                                    </div>
                                    <div class="row">

                                        <div class="col-50 patient_app_info">
                                            <div><span class="label">MR No:</span> {{ appointment.patients ? appointment.patients.customer_code : '' }}</div>
                                            <div><span class="label">Name:</span> {{ appointment.patient_name }}</div>
                                            <div><span class="label">Age:</span> {{ appointment.patient_age }}</div>
                                            <div><span class="label">Gender:</span> {{ appointment.patient_gender }}</div>
                                            <div><span class="label">Address:</span> {{ appointment.patients ? appointment.patients.address : '' }}</div>
                                            <div><span class="label">Cell:</span> {{ appointment.patient_phone }}</div>
                                        </div>
                                        <div class="col-50 patient_app_info">
                                            <div><span class="label">Bill No:</span> {{ appointment.serial_no }}</div>
                                            <div><span class="label">Date:</span> {{ this.formatDate(appointment.appointment_date) }}</div>
                                            <div><span class="label">Time:</span> {{ this.formatAppointmentTime(appointment.appointment_time) }}</div>
                                            <div><span class="label">Email:</span> {{ appointment.patients ? appointment.patients.email : '' }}</div>
                                            <div><span class="label">Referred By:</span> </div>
                                            <div><span class="label">Operator:</span> {{ loggedInUser.name }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="divider"></div>
                                <!-- CLINICAL PART -->
                                <div class="section">
                                    <div><span class="label">Chief Complaint:</span></div>
                                    <div class="line-box"></div>

                                    <div><span class="label">Present History:</span></div>
                                    <div class="line-box"></div>

                                    <div><span class="label">Past Ocular History:</span></div>
                                    <div class="line-box"></div>

                                    <div><span class="label">Medical History:</span>
                                        HPN ☐ Cardiac ☐ DM ☐ Thyroid ☐ Asthma ☐ Other ☐
                                    </div>
                                    <div class="line-box"></div>
                                </div>

                                <!-- VISION TABLE -->
                                <div class="section">
                                </div>

                                <!-- CUT LINE -->
                                <div class="dashed"></div>

                                <!-- BOTTOM PART -->
                                <div class="section row">

                                    <!-- LEFT TEXT / NOTE AREA -->
                                    <div class="col-60 pe-0">
                                        <div class="receipt">
                                            <div class="receipt-header">
                                                {{ this.prescriptionHospitalName }}<br>
                                                <small style="font-size: 8px;">{{ this.prescriptionAddress }}
                Phone: {{ this.prescriptionPhone }} | Email: {{ this.prescriptionEmail }}</small>
                                            </div>

                                            <table style="border-right: 0">
                                                <tr>
                                                    <td style="border-left: 0;"><strong>MR No: </strong> {{ appointment.patients ? appointment.patients.customer_code : '' }}</td>
                                                    <td style="border-right: 0;"><strong>Date: </strong> {{ this.formatDate(appointment.appointment_date) }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="border-left: 0; border-right: 0;"><strong>Name: </strong> {{ appointment.patient_name }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="border-left: 0; border-right: 0;"><strong>Address: </strong> {{ appointment.patients ? appointment.patients.address : '' }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="height: 16px; border-left: 0; border-right: 0;"></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="height:60px; font-size:10px; border-left: 0; border-right: 0; border-bottom: 0;">
                                                        রোগীকে ডাক্তারের পরামর্শ অনুযায়ী প্রয়োজনীয় পরীক্ষা করাতে হবে।<br>
                                            নির্ধারিত তারিখে রিপোর্টসহ উপস্থিত থাকতে হবে।
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                    <!-- MONEY RECEIPT (IMAGE MATCHED) -->
                                    <div class="col-40 ps-0">
                                        <div class="receipt">
                                            <div class="receipt-header">
                                                {{ this.prescriptionHospitalName }}<br>
                                                <small>Out-Patient Record</small>
                                            </div>

                                            <table>
                                                <tr>
                                                    <!-- <td style="border-left: 0;"><strong>MR No: </strong> {{ appointment.patients ? appointment.patients.customer_code : '' }}</td> -->
                                                    <td colspan="2" style="border-left: 0; border-right: 0;"><strong>Receipt No: </strong> {{ appointment.serial_no }}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" style="border-left: 0; border-right: 0;"><strong>Name: </strong> {{ appointment.patient_name }}</td>
                                                </tr>
                                                <tr>
                                                    <td style="border-left: 0;"><strong>Details</strong></td>
                                                    <td style="border-right: 0; text-align: center;">Amount (TK)</td>
                                                </tr>
                                                <tr style="height: 38px;">
                                                    <td style="border-left: 0;">Consulting Fees</td>
                                                    <td style="border-right: 0; text-align: right; font-weight: 600;">{{ appointment.receivable_amount }}</td>
                                                </tr>
                                                <tr style="height: 38px;">
                                                    <td style="border-left: 0; border-bottom: 0;">
                                                        <span style="display: block; padding-left: 30px;">{{ this.formatDate(appointment.appointment_date) }} </span>
                                                        <span style="display: block; margin-left: 20px; width: 80%; border-top:1px solid #ccc;"></span>
                                                        <strong style="display: block; padding-left: 20px;">Date</strong>
                                                    </td>
                                                    <td style="border-right: 0; border-bottom: 0;">
                                                        <span style="display: block; padding-left: 30px;">{{ loggedInUser.name }}</span>
                                                        <span style="display: block; margin-left: 20px; width: 80%; border-top:1px solid #ccc;"></span>
                                                        <strong style="display: block; padding-left: 20px;">Cashier</strong>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <!-- <div class="appointment_token" style="text-align: center;" v-if="tokenPrintModalActive">
                            <h3 style="text-align: center;">{{ (appointment.serial_no).slice(-4) }}</h3>
                            <h5 style="text-align: center;">Patient: {{ appointment.patient_name }}</h5>
                            <p style="text-align: center;">Doctor: {{ appointment.doctor_name }}</p>
                            <p style="text-align: center;">Department: {{ appointment.department_name }}</p>
                            <p style="text-align: center;">Date: {{ appointment.appointment_date }}</p>
                        </div> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="toggleTokenPrintModal()">
                            Close
                        </button> 
                        <button type="button" class="btn btn-primary " @click="printContent('printTokenArea', print_ar_css_url)">
                            <i class="fas fa-print" ></i> Print Token
                        </button>
                    </div>
                </div>
            </Modal>


            <!-- Prescription View For Pad -->
            <Modal @close="prescriptionViewModal()" :modalActive="showPrescriptionModal">
                <div class="modal-content scrollbar-width-thin prescription-view-modal">
                    <div class="modal-header"> 
                        <h5 class="">Prescription View</h5>
                        <button @click="prescriptionViewModal" type="button" class="btn btn-danger"><i class="mdi mdi-close"></i></button>
                    </div> 
                    <div class="modal-body" v-if="prescription">  
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div id="prescriptionArea" class="card-body prescription">
                                        <!-- Prescription Body -->
                                        <div class="prescription_body">
                                            <!-- Patient Details -->
                                            <div class="row">
                                                <div class="col-md-12 table-patient-info">
                                                    <table class="table patient_info">
                                                        <tbody>
                                                            <tr>
                                                                <td width="50%" class="p_name">{{ prescription.patient.name }}</td>
                                                                <td width="20%" class="p_age" style="font-size: 13px; padding-top: 12px; word-spacing: -2px;">{{ prescription.age }} </td>
                                                                <td width="15%" class="p_weight">{{ prescription.weight }}</td>
                                                                <td width="15%" class="p_date">{{ prescription.prescription_view_date }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <!-- Medicines & Test Details -->
                                            <div class="row">
                                                <div class="col-md-5 col-xs-5">
                                                    <div class="left-container">
                                                        <div class="test_details">
                                                            <div class="basic_test_info">
                                                                <ul>
                                                                    <li>Blood Pressure: <span>{{ (prescription.blood_pressure) ? prescription.blood_pressure : '---' }}</span></li>
                                                                    <li>Pulse Rate: <span>{{ (prescription.pulse_rate) ? prescription.pulse_rate : '---' }}</span></li>
                                                                    <li>Temperature: <span>{{ (prescription.temperature) ? prescription.temperature : '---' }}</span></li>
                                                                    <li>Blood Sugar: <span>{{ (prescription.diabetic) ? prescription.diabetic : '---' }}</span></li>
                                                                    <li>Diagnosis: <span>{{ (prescription.problem_description) ? prescription.problem_description : '---' }}</span></li>
                                                                </ul>
                                                            </div>
                                                            <div class="examines">
                                                                <ul v-if="prescription.test_items">
                                                                    <li v-for="(test_item ,index) in prescription.test_items" :key="index">{{ test_item.name }}</li>     
                                                                </ul>
                                                            </div>                                                    
                                                            <div class="advices">
                                                                <ul v-if="prescription_advices.length > 0">
                                                                    <li v-for="(advice, i) in prescription_advices" :key="i">{{ (advice) ? advice : '' }}</li>
                                                                </ul>
                                                            </div>

                                                            <div class="next_visit">
                                                                <p><span class="visit_days">{{ prescription.next_visit ?? '' }}</span></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-7 col-xs-7 pl-0">                                                    
                                                    <div class="medicine_details">
                                                        <ul v-if="prescription.medicine_items">
                                                            <li v-for="(medicine_item ,index) in prescription.medicine_items" :key="index">
                                                                <h5>{{ index + 1}}. {{ medicine_item.name }}</h5>
                                                                <p>
                                                                    <span>Dosage: {{ medicine_item.dose_interval }}</span> 
                                                                    <!-- <span style="padding-left: 10px" v-if="medicine_item.cat_name == 'Syrup'"><i>---</i> {{ medicine_item.dosage+ ' spoon' }}</span>
                                                                    <span style="padding-left: 10px" v-else-if="medicine_item.cat_name == 'Tablet'"><i>---</i> {{ medicine_item.dosage+ ' pcs'}}</span>
                                                                    <span style="padding-left: 10px" v-else-if="medicine_item.cat_name == 'Capsul'"><i>---</i> {{ medicine_item.dosage+ ' pcs'}}</span> -->
                                                                    <span style="padding-left: 10px"><i>---</i> {{ medicine_item.dose_time }}</span>
                                                                    <span style="padding-left: 10px" v-if="medicine_item.dose_duration != ''"><i>---</i> {{ medicine_item.dose_duration }}</span>
                                                                </p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> <!-- end card-body-->
                                </div> <!-- end card-->
                            </div> <!-- end col-->  
                        </div>
                    </div>
                    <div class="modal-footer"> 
                        <button type="button" class="btn btn-danger" @click="prescriptionViewModal()">
                            Close
                        </button> 
                        <button type="button" class="btn btn-primary" @click="printPrescription()">
                            Print
                        </button> 
                    </div>
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Appointments',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            showPrescriptionModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            tokenPrintModalActive:false,
            loggedInUser: this.$store.getters.userData.user || '',
            print_ar_css_url: this.baseUrlPrintCSS + '/assets/css/print_appointment_registration_invoice.css',
            errors: {},
            imagePreview: '',
            btn:'Create',
            renderOptionComponent: true,
            costCenterOptions: [],
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id+'___'+node.code,
                    label: node.name,
                    children: node.children,
                }
            },
            items: [],
            appointment: {},
            appointments: [],
            patients: [],
            patient_options: [],
            doctors: [],
            doctor_options: [],
            departments: [],
            department_options: [],
            prescription: '',
            prescription_advices: [],
            loading: true,
            companies: [],
            form: new Form({
                id: '',
                patient_id: '', 
                patient_name: '', 
                patient_phone: '', 
                department_id: '',
                doctor_id: '',
                appointment_date: '',   
                status: 0,
                cost_center_id: null,
                payment_type: 'cash',
                amount: '',

            }),
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },            
            columns: [ 
                {
                    label: 'SL',
                    name: '',  
                    isSearch: false, 
                    isAction: true,         
                    width: '5%'
                }, 
                {
                    label: 'Date',
                    name: 'date',
                    width: '10%'
                },    
                {
                    label: 'Serial No',
                    name: 'serial_no',
                    width: '15%'
                },    
                {
                    label: 'Patient',
                    name: 'patient_name',
                    width: '10%'
                },
                {
                    label: 'Phone',
                    name: 'patient_phone',
                    width: '10%'
                },
                {
                    label: 'Schedule',
                    name: 'schedule',
                    width: '15%'
                },
                {
                    label: 'Doctor',
                    name: 'doctor_name',
                    width: '15%'
                },
                {
                    label: 'Dept.',
                    name: 'department_name',
                    width: '10%'
                },
                {
                    label: 'Status',
                    name: 'status',
                    width: '7%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '18%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 2,
                dir: 'asc',
                sortKey: 'serial_no', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }

        };
    },
    created() { 
        this.getAppointmentList();
        this.fetchPatients();
        this.fetchDepartments();
        this.fetchDoctors();
        this.fetchCostCenters();
    },
    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        redirectRoute(url) {
            this.$router.push({ path: url });
        },

        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();  
        },
         
        toggleProfileModal: function() {  
            this.showModal = !this.showModal;
        },
         
        toggleTokenPrintModal: function() {  
            this.tokenPrintModalActive = !this.tokenPrintModalActive;
            if(this.tokenPrintModalActive) {
                setTimeout(() => {
                    this.printContent('printTokenArea', this.print_ar_css_url);
                    this.tokenPrintModalActive = false;
                }, 2000);
            }
        },

        tokenPrint: function(item) {  
            this.appointment = item;
            this.toggleTokenPrintModal();
        },

        getPaymentReceiveUrl(appointmentId) {
            return `/accounting/receive-payment?appointment_id=${appointmentId}`;
        },

        printContent(document_id, css_url='') {
            const width = 900;
            const height = 650;
            const left = (screen.width / 2) - (width / 2);
            const top = (screen.height / 2) - (height / 2);

            const options = {
                name: '_blank',
                specs: [
                    `width=${width}`,
                    `height=${height}`,
                    `top=${top}`,
                    `left=${left}`,
                    'scrollbars=yes',
                    'resizable=yes',
                    'titlebar=yes'
                ],
                styles: [
                    this.baseUrlPrintCSS + '/assets/css/bootstrap-print.min.css',
                    css_url
                ],
            };

            this.$htmlToPaper(document_id, options);
        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 

        fetchCostCenters()
        {
            axios.get(this.apiUrl+'/cost_centers', this.headerjson)
            .then((res) => {
                this.costCenterOptions = res.data.data.cost_center_options;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        },

        fetchPatients() { 
            axios.get(this.apiUrl+'/hm/patients', this.headerjson)
            .then((res) => {
                this.patients = res.data.data;
                // this.patient_options = [{label: "Select Patient", value: ""}];
                res.data.data.map((item) => {
                    this.patient_options.push({label:item.name + " - " + item.phone, value:item.id});
                }); 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
            });
        }, 
        fetchDepartments() { 
            axios.get(this.apiUrl+'/hm/departments', this.headerjson)
            .then((res) => {
                this.departments = res.data.data; 
                // this.department_options = [{label: "Select Department", value: ""}];
                res.data.data.map((item) => {
                    this.department_options.push({label:item.name, value:item.id});
                });
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 

         // Products Data
        fetchDoctors() {
            axios.get(this.apiUrl+"/hm/doctors", this.headerjson)
            .then((resp) => {
                this.doctors  = resp.data.data;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        onChangeDepartment(dept_id) {

            this.forceRerender();

            if(dept_id != 0) {
                let department_doctors = this.doctors.filter((item, index) => {
                    return item.department_id == dept_id;
                });

                if(department_doctors.length > 0) {
                    this.doctor_options = department_doctors.map((item) => { 
                        return {label:item.name, value:item.id};
                    });
                }
            }

        },

        show: function(item) {     
            axios.get(this.apiUrl+'/customers/'+item.id, this.headers).then(res => {
                if(res.status == 200){  
                    this.customer = res.data.data
                    this.showModal = !this.showModal;  
                }else{
                    this.$toast.error(res.data.message);
                }
                console.log(res.data.data)
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            }) 
        },

        // edit: function(item) { 
        //     this.btn='Update';
        //     this.editMode = true;
        //     this.toggleModal();
        //     let department_doctors = this.doctors.filter((doctor, index) => {
        //             return doctor.department_id == item.department_id;
        //     });

        //     if(department_doctors.length > 0) {
        //         this.doctor_options = department_doctors.map((item) => { 
        //             return {label:item.name, value:item.id};
        //         });
        //     }

        //     this.form.fill(item);  
        // },

        registerPatient: function(item) {
            this.$router.push({ 
                path: '/appointments/create', 
                query: { appointment_id: item.id, type: 'registration', redirect: 'today' } 
            }); 
        },


        generateSales: function(item) {
            const routerData = this.$router.resolve({
                path: '/pos-for-prescription',
                query: { appointment_id: item.id, type: 'fromPatient'}
            });

            window.open(routerData.href, "_blank");
        }, 

        edit: function(item) { 
            this.$router.push({ 
                path: '/appointments/create', 
                query: { appointment_id: item.id, redirect: 'today' } 
            }); 
        },

        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();              
            formData.append('patient_name', this.form.patient_name);
            formData.append('patient_phone', this.form.patient_phone);
            formData.append('department_id', this.form.department_id);
            formData.append('doctor_id', this.form.doctor_id);
            formData.append('appointment_date', this.form.appointment_date);
            formData.append('status', this.form.status);
            formData.append('cost_center_id', this.form.cost_center_id);
            formData.append('payment_type', this.form.payment_type);
            formData.append('amount', this.form.amount);

            if(this.editMode){
                formData.append('_method', 'put');
                var postEvent = axios.post(this.apiUrl+'/hm/appointments/'+this.form.id, formData, this.headers);
            }else{  
                var postEvent = axios.post(this.apiUrl+'/hm/appointments', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.appointment = res.data.data;
                    this.toggleTokenPrintModal();
                    this.getAppointmentList();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        // onImageChange(e) {
        //     this.form.cimage = e.target.files[0]
        //     let files = e.target.files || e.dataTransfer.files;
        //     if (!files.length)
        //         return;  
            
        //     this.createImage(files[0]);

        // },
        // createImage(file) {
        //     let reader = new FileReader();
        //     let vm = this;
        //     reader.onload = (e) => { 
        //         vm.imagePreview = e.target.result;
        //     };
        //     reader.readAsDataURL(file);
        // },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        getStatusBadgeClass(status) {
            if(status == 0) {
                return 'btn-warning';
            } else if(status == 1) {
                return 'btn-info';
            } else if(status == 2) {
                return 'btn-primary';
            } else if(status == 3) {
                return 'btn-success';
            } else if(status == 4) {
                return 'btn-danger';
            } else {
                return 'btn-secondary';
            }
        },

        getStatusLabel(status) {
            if(status == 0) {
                return 'Pending';
            } else if(status == 1) {
                return 'Confirmed';
            } else if(status == 2) {
                return 'Present';
            } else if(status == 3) {
                return 'Done/Complete';
            } else if(status == 4) {
                return 'Cancelled';
            } else {
                return 'Unknown';
            }
        },

        updateStatus: function(item, status, type) {
            var statusText = 'You want to update this appointment?';
            if(type == 'confirmed') {
                statusText = 'You want to '+type+' this appointment?';
            }

            if(type == 'pending') {
                statusText = 'You want to '+type+' this appointment?';
            }

            if(type == 'complete') {
                statusText = 'You want to '+type+' this appointment?';
            }

            if(type == 'present') {
                statusText = 'This appointment patient is '+type+'?';
            }

            if(type == 'absent') {
                statusText = 'This appointment patient is '+type+'?';
            }

            if(type == 'cancel') {
                statusText = 'This appointment is '+type+'?';
            }

            const formData = new FormData();              
            formData.append('status', status);
            formData.append('_method', 'put');

            this.$swal({
                title: 'Are you sure?',
                text: statusText, 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Confirm'
            }).then((result) => { 
                if (result.value) { 
                    var postUpdateEvent = axios.post(this.apiUrl+'/hm/appointments/status_update/'+item.id, formData, this.headers);
                    postUpdateEvent.then(res => {
                        if(res.status == 200){  
                            this.getAppointmentList();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        generatePrescription: function(item) {
            const psotEvent = axios.post(this.apiUrl+'/hm/appointments/generate_prescriptions', {appointment_id:item.id}, this.headers);
            psotEvent.then(res => {
                if(res.status == 200){  
                    this.getAppointmentList();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => {  
                this.$toast.error(err.response.data.message); 
            })
        },

        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this appointment!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/appointments/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.getAppointmentList();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        // For Pagination 
        getAppointmentList(url = this.apiUrl+'/hm/appointments/today') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.appointments = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getAppointmentList();
        },
        setPage(data){  
            this.getAppointmentList(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        printAppointmentList: function () {   
            this.printContent('printArea');
        },
         
        prescriptionViewModal: function() {  
            this.showPrescriptionModal = !this.showPrescriptionModal;
        },

        prescriptionView: function(item, type='view') {                 
            
            let formData = new FormData();
            if(type == 'submit') {
                var appointment_id = item.appointment_id
            }else {
                appointment_id = item.id
            }

            formData.append("appointment_id", appointment_id);
            axios.post(this.apiUrl+'/hm/prescriptions/get-by-id', formData, this.headers)
            .then(res => {            
                this.showPrescriptionModal = !this.showPrescriptionModal;
                if(res.status == 200){ 
                    this.prescription = res.data.data; 
                    if(res.data.data.advice != 'null' || res.data.data.advice != '') {
                        this.prescription_advices = res.data.data.advice.split(";");
                    }
                    if(type == 'submit') {
                        setTimeout(()=>{ this.printPrescription(); }, 1000);
                    }
                } else {
                    this.$toast.error(res.message);
                }
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors;
                }
            })
        },

        printPrescription: function() {
            // let printStyleLink = this.baseUrlPrintCSS+'/assets/css/print_prescription.css';
            let printStyleLink = this.baseUrlPrintCSS+'/assets/css/print_prescription_pad.css';
            this.printContent('prescriptionArea', printStyleLink);
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 700px;
}

.modal-content.scrollbar-width-thin.prescription-view-modal {
    border: none !important;
    width: 900px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}


/** For Invoice Print */
    #printTokenArea .page {
        border: 1px solid #000;
        padding: 10px;
        font-size: 14px;
    }
    #printTokenArea .header {
        text-align: center;
        border-bottom: 1px solid #000;
        padding-bottom: 5px;
    }
    #printTokenArea .header h2 {
        margin: 0;
        font-size: 16px;
    }
    #printTokenArea .header small {
        font-size: 11px;
    }
    #printTokenArea .section {
        margin-top: 8px;
    }
    #printTokenArea .row {
        display: flex;
        justify-content: space-between;
    }
    #printTokenArea .col-50 { width: 50%; }
    #printTokenArea .col-60 { width: 60%; }
    #printTokenArea .col-40 { width: 40%; }

	#printTokenReceipt .patient_app_info {
		line-height: 1.8;
	}

    #printTokenArea .label { font-weight: bold; }
    #printTokenArea table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 5px;
    }

    #printTokenArea td, th {
        border: 1px solid #000;
        padding: 3px;
        vertical-align: top;
    }
    #printTokenArea .no-border td {
        border: none;
    }
    #printTokenArea .line-box {
        height: 40px;
        /* border-bottom: 1px solid #000; */
        margin-bottom: 4px;
    }
    #printTokenArea .divider {
        border-top: 1px solid #000;
        margin: 15px 0;
    }
    #printTokenArea .dashed {
        border-top: 1px dashed #000;
        margin: 12px 0;
    }
    #printTokenArea .receipt {
        border: 1px solid #000;
        font-size: 12px;
    }
    #printTokenArea .receipt-header {
        text-align: center;
        border-bottom: 1px solid #000;
        padding: 4px;
        font-weight: bold;
        min-height: 40px;
    }


    /* Prescription CSS */
    #prescriptionArea {
        background: url('/assets/pad_prescriptions/outdoor_prescription.jpg') no-repeat;
        background-size: 100% 100%;
        /* font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important; */
        font-family: Tahoma, "Trebuchet MS", sans-serif !important;
        /* border: 1px solid #a19b9b; */
        padding: 0;
    }

    #prescriptionArea h1, h2, h3, h4, h5, h6  {
    font-family: Tahoma, "Trebuchet MS", sans-serif !important;
    }

    .table.patient_info {
        margin-top: 216px;
        margin-bottom: 0;
        padding: 15px;
        color: #000000;
    }
    .table.patient_info tr td { 
        border: none;
        padding: 10px 15px;
        font-size: 15px;
        font-weight: 400;
    }

    .table.patient_info .p_name {
        padding-left: 95px;
    }

    .table.patient_info .p_age {
        padding-left: 65px;
    }

    .table.patient_info .p_weight {
        padding-left: 40px;
    }

    .table.patient_info .p_date {
        padding-left: 30px;
    }

    .left-container {
        /* padding: 30px 15px 15px 15px; */
        /* background-color: #F0F9FE; */
        margin-right: 35px;
    }
    .test_details {
        position: relative;
        padding: 20px;
        min-height: 850px; /* Adjust the height as needed */
    }

    .basic_test_info {
        min-height: 170px;
        margin-top: 60px;
        padding-left: 55px;
    }

    .examines {
        min-height: 175px;
        margin-top: 25px;
        padding-left: 55px;
    }

    .advices {
        min-height: 225px;
        margin-top: 25px;
        padding-left: 55px;
    }

    .basic_test_info h5, .advices h5, .examines h5 {
        font-weight: 400;
    }

    .basic_test_info ul li, .advices ul li, .examines ul li {
        font-size: 14px;
    }

    .next_visit {
        min-height: 100px;
        margin-top: 13px;
        padding-left: 55px;
    }

    .next_visit p {
        /* color:#ff0000; */
        color:#000000;
        font-size: 14px;
        font-weight: 500;
    }

    .next_visit p:first-child {
        margin-left: 40px;
    }

    .next_visit p span.visit_days {
        position: relative;
        display: inline-block;
        width: 20%;
        margin-right: 20px;
    }

    .pl-0 {
        padding-left: 0 !important;
    }

    .medicine_details {
        padding-top: 55px;
    }

    .medicine_details ul {
        list-style: none;
        padding-left: 0;
    }

    .medicine_details ul li h5{
        font-weight: 400;
    }

    .medicine_details ul li p{
        padding-left: 20px;
        font-size: 14px;
    }
</style>